// components/FileUpload.js
import React from 'react';
import { useTheme } from '../../../hooks/ThemeProvider';

const FileUpload = ({ formData, errors, onFileUpload }) => {
      const { theme, toggle } = useTheme();
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Validate file size (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                onFileUpload(null, "File size must be less than 5MB");
                return;
            }

            // Validate file type
            if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
                onFileUpload(null, "Please upload JPEG or PNG image only");
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                onFileUpload(file, null, e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <div className="imageupload">
            <div className="left">
                <span>
                    {formData.logoPreview ? (
                        <img
                            src={formData.logoPreview}
                            className='logoprivew'
                            alt="Logo preview"
                        />
                    ) : (
                        <div>
                            {
                                theme === 'dark' ? <img src="\assets\downlod.svg" /> :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                                        <path d="M20.5833 3.75H5.41667C4.22005 3.75 3.25 4.72005 3.25 5.91667V21.0833C3.25 22.28 4.22005 23.25 5.41667 23.25H20.5833C21.78 23.25 22.75 22.28 22.75 21.0833V5.91667C22.75 4.72005 21.78 3.75 20.5833 3.75Z" stroke="#000F2F" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.75065 12.4166C10.9473 12.4166 11.9173 11.4466 11.9173 10.25C11.9173 9.05336 10.9473 8.08331 9.75065 8.08331C8.55403 8.08331 7.58398 9.05336 7.58398 10.25C7.58398 11.4466 8.55403 12.4166 9.75065 12.4166Z" stroke="#000F2F" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M22.75 16.75L19.4068 13.4068C19.0005 13.0006 18.4495 12.7725 17.875 12.7725C17.3005 12.7725 16.7495 13.0006 16.3432 13.4068L6.5 23.25" stroke="#000F2F" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                            }

                        </div>

                    )}
                </span>
                <div className="leftcontent">
                    <h3>Project Logo *</h3>
                    <p>
                        We recommend to upload images in 500x500 resolution. Max 5 MB in JPEG or PNG.
                    </p>
                    {errors.logo && <p className="error-text-2">{errors.logo}</p>}
                </div>
            </div>
            <div className="right">
                <div className="wrapper">
                    <label htmlFor="upload">Upload</label>
                    <input
                        type="file"
                        id="upload"
                        accept="image/jpeg,image/jpg,image/png"
                        onChange={handleFileChange}
                        className="d-none"
                    />
                </div>
            </div>
        </div>
    );
};

export default FileUpload;